import { render, staticRenderFns } from "./SummaryMessageBox.vue?vue&type=template&id=3d7d21fe&scoped=true&"
import script from "./SummaryMessageBox.vue?vue&type=script&lang=js&"
export * from "./SummaryMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./SummaryMessageBox.vue?vue&type=style&index=0&id=3d7d21fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7d21fe",
  null
  
)

export default component.exports